import React from 'react'
import EventList from '../components/EventA/EventList'

export default function Events() {
  return (
    <React.Fragment>
      <EventList />
    </React.Fragment>
  )
}
